import {
  QueryFunctionContext,
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import { ZontalInformationPackageProfile, ZontalInformationPackageProfileFilters } from "../api/Zontal";
import { useContext } from "react";
import { SessionContext } from "../common/contexts/SessionContext";
import { ResourceName } from "../main/Routing";

interface ZontalPagination {
  results: ZontalInformationPackageProfile[];
  hasNext: boolean;
}

export const useInfiniteListZontalIPP = (
  resource: ResourceName,
  params: ZontalInformationPackageProfileFilters,
  options?: UseInfiniteQueryOptions<any, unknown, ZontalPagination, any>
): UseInfiniteQueryResult<ZontalPagination> => {
  const { api } = useContext(SessionContext);

  const getDataByPageParamPost = async (pageParam: string | undefined, signal?: AbortSignal) => {
    if (pageParam) {
      const response: ZontalPagination = await api.post(
        resource,
        {
          ...params,
          searchAfter: pageParam,
        },
        undefined,
        signal
      );
      return response;
    } else {
      const response: ZontalPagination = await api.post(resource, params, undefined, signal);
      return response;
    }
  };
  const getData = async ({ pageParam, signal }: QueryFunctionContext<QueryKey, string>): Promise<ZontalPagination> => {
    return await getDataByPageParamPost(pageParam, signal);
  };

  const res = useInfiniteQuery({
    queryKey: [resource, params],
    queryFn: async (queryFnContext) => await getData(queryFnContext),
    getNextPageParam: (lastPage: ZontalPagination) =>
      lastPage.hasNext && lastPage.results.length > 0 ? lastPage.results[lastPage.results.length - 1].id : undefined,
    cacheTime: 0, // Each new query will be considered fresh; No caching!
    ...options,
  });

  return res;
};
